import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../firebase'; // Adjust the path if needed
import { doc, getDoc, updateDoc, Timestamp } from 'firebase/firestore';
import './NewsDetails.css'; // Import the CSS file

const NewsDetails = () => {
  const { newsId } = useParams(); // Get the newsId from the URL
  const navigate = useNavigate();
  const [newsItem, setNewsItem] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    date: '',
    description: '',
    image: '',
    link: '',
  });

  // Function to fetch news details from Firestore
  const fetchNewsDetails = async () => {
    const newsRef = doc(db, 'news', newsId); // Adjust the collection name if needed
    const newsSnapshot = await getDoc(newsRef);
    if (newsSnapshot.exists()) {
      setNewsItem({ id: newsSnapshot.id, ...newsSnapshot.data() });
      setFormData({
        title: newsSnapshot.data().title,
        date: new Date(newsSnapshot.data().date.seconds * 1000).toISOString().slice(0, 10), // Format date for input
        description: newsSnapshot.data().description,
        image: newsSnapshot.data().image,
        link: newsSnapshot.data().link,
      });
    } else {
      console.log('No such document!');
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchNewsDetails();
  }, [newsId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSave = async () => {
    const newsRef = doc(db, 'news', newsId); // Adjust the collection name if needed
    await updateDoc(newsRef, {
      title: formData.title,
      date: Timestamp.fromDate(new Date(formData.date)), // Convert to Firestore timestamp format
      description: formData.description,
      image: formData.image,
      link: formData.link,
    });
    setNewsItem({ ...newsItem, ...formData }); // Update local state
    setIsEditing(false); // Exit editing mode
  };

  if (!newsItem) return <div className="loading">Loading...</div>;

  return (
    <div className="news-details">
      <h2 className="news-title">
        {isEditing ? (
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            className="news-input"
          />
        ) : (
          newsItem.title
        )}
      </h2>
      <h4 className="news-date">
        {isEditing ? (
          <input
            type="date"
            name="date"
            value={formData.date}
            onChange={handleInputChange}
            className="news-input"
          />
        ) : (
          new Date(newsItem.date.seconds * 1000).toLocaleString()
        )}
      </h4>
      <p className="news-description">
        {isEditing ? (
          <textarea
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            className="news-textarea"
          />
        ) : (
          newsItem.description
        )}
      </p>
      {isEditing ? (
        <div className="news-image-container">
          <input
            type="text"
            name="image"
            value={formData.image}
            onChange={handleInputChange}
            className="news-input"
            placeholder="Image URL"
          />
        </div>
      ) : (
        newsItem.image && (
          <div className="news-image-container">
            <img src={newsItem.image} alt={newsItem.title} className="news-image" />
          </div>
        )
      )}
      {isEditing ? (
        <input
          type="text"
          name="link"
          value={formData.link}
          onChange={handleInputChange}
          className="news-input"
          placeholder="Link URL"
        />
      ) : (
        newsItem.link && (
          <p className="news-link">
            Read more: <a href={newsItem.link} target="_blank" rel="noopener noreferrer">{newsItem.link}</a>
          </p>
        )
      )}
      <div className="news-buttons">
        {isEditing ? (
          <button onClick={handleSave} className="save-button">Save Changes</button>
        ) : (
          <button onClick={() => setIsEditing(true)} className="edit-button">Edit</button>
        )}
        <button onClick={() => navigate(-1)} className="back-button">Back</button>
      </div>
    </div>
  );
};

export default NewsDetails;
